type Props = {
  eyebrow?: string;
  title: string;
  desc?: string;
  right?: string;
};

export default function SectionTitle({ eyebrow, title, desc, right = "查看更多" }: Props) {
  return (
    <div className="mb-5 flex flex-col gap-3 border-b border-background-200 pb-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && (
          <div className="mb-1.5 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-700">
            <i className="ri-record-circle-line"></i>{eyebrow}
          </div>
        )}
        <h2 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">{title}</h2>
        {desc && <p className="mt-1 text-sm text-foreground-600">{desc}</p>}
      </div>
      <a href="#feed" className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-foreground-600 hover:text-primary-700">
        {right}
        <i className="ri-arrow-right-line text-xs"></i>
      </a>
    </div>
  );
}